import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import { CustomExportButton } from "./CustomExportButton";
import { CustomPreviewButton } from "./CustomPreviewButton";
import { CustomAddCvButton } from "./CustomAddCvButton";


export const CustomGridToolbar = ({
  apiRef,
  handleClickOpen,
}: // handleClickOpen,
{
  apiRef: React.RefObject<GridApiCommunity>;
  handleClickOpen: () => void;
}) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <CustomExportButton apiRef={apiRef} />
      <CustomPreviewButton apiRef={apiRef} />
      <CustomAddCvButton apiRef={apiRef} handleClickOpen={handleClickOpen} />
    </GridToolbarContainer>
  );
};
